<template>
  <transition
    @enter="enter"
    @leave="leave"
    appear
  >
    <aside
      :key="voice.id"
      class="next"
      v-if="voice.id !== undefined"
      style="opacity: 0;"
      :style="{ pointerEvents: $store.state.isTrans ? 'none' : 'auto' }"
    >
      <div
        class="breadcrumbs__wrapper"
        :data-project="voice.project"
      >
        <Breadcrumbs
          :voice="voice"
          :hover="hover"
          direction="next"
          trans="siblings"
        />
      </div>
      <div
        class="next__wrapper"
      >
        <a
          :href="voice.url"
          :data-nav="voice.id"
          :aria-label="voice.text"
          class="next__link"
          @click.prevent="$goTo(voice.url, 'siblings');"
          @mouseenter="hover = true;"
          @mouseleave="hover = false;"
        >
          <Title
            :text="voice.text"
            :size="$route.name === 'project' ? 'normal' : $route.name === 'person' ? 'team' : 'big'"
            data-anim="title-next"
          />
        </a>
      </div>
    </aside>
  </transition>
</template>

<script>
import upperCase from 'lodash/upperCase';
import { TweenMax, Expo } from 'gsap/TweenMax';
import { mapGetters } from 'vuex';

import { initial, animations } from '@/assets/animations';
import translate from '@/assets/i18n';

import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';
import Title from '@/components/text/Title.vue';

export default {
  name: 'Next',

  components: {
    Breadcrumbs,
    Title,
  },

  data() {
    return {
      voice: {},
      voiceClone: {},
      signal: false,
      hover: false,
    };
  },

  computed: {
    ...mapGetters({
      routeName: 'getRouteName',
      init: 'getInit',
    }),
  },

  watch: {
    init(n) {
      this.change(this.routeName);
    },

    routeName(n) {
      if (n && this.init) {
        setTimeout(() => {
          this.change(n);
        }, 500);
      }
    },
  },

  mounted() {
    // this.$eventHub.$on('leave', this.checkClone);
  },

  beforeDestroy() {
    // this.$eventHub.$off('leave', this.checkClone);
  },

  methods: {
    enter(el, done) {
      this.$nextTick(() => {
        if (el.style !== undefined) {
          el.style.opacity = '1';

          Array.from(el.querySelectorAll('[data-anim]:not([data-animated])')).forEach((element) => {
            initial.get(element.dataset.anim)(element);
          });
        }
      });
      done();
    },

    leave(el, done) {
      TweenMax.to(el, 0.5, {
        autoAlpha: 0,
        x: 20,
        ease: Expo.easeOut,
        onComplete: done,
      });
    },

    change(route) {
      if (route === 'home' || this.$route.name === 'error404') {
        this.voice = {};
      } else {
        let order = 0;

        const active = route;
        const { lang } = this.$store.state;
        const projects = this.$route.name !== 'project' ? this.$route.name !== 'person' ? '' : '/team' : lang === 'it' ? '/investimenti' : '/investments';
        const pathLang = lang === 'it' ? 'path' : 'pathEn';
        const data = this.$route.name === 'project' ? this.$store.state.firebase.investimenti.childrens : this.$route.name === 'person' ? this.$store.state.firebase.team.childrens : this.$store.state.firebase;

        Object.keys(data).forEach((key) => {
          if (key === active) {
            if (data[key].order === Object.keys(data).length - 1) {
              order = this.$route.name !== 'project' && this.$route.name !== 'person' ? 0 : -1;
            } else {
              order = data[key].order;
            }
          }
        });

        Object.keys(data).forEach((key) => {
          if (data[key].order === order + 1) {
            this.voice = {
              id: key,
              url: `/${lang}${projects}${data[key][pathLang]}`,
              text: this.$route.name !== 'project' && this.$route.name !== 'person' ? translate(upperCase(key), lang) : data[key].name,
              label: 'Next',
              project: this.$route.name === 'project' || this.$route.name === 'person',
            };

            this.$store.commit('SET_NEXT', this.voice);
          }
        });

        if (this.voice.id !== undefined) {
          this.$nextTick(() => {
            this.voiceClone = {
              dataNav: this.voice.id,
              el: document.querySelector('.next__link'),
            };

            // this.clone();
          });
        }
      }
    },

    clone() {
      this.$eventHub.$emit('addTitleCloning', this.voiceClone);
    },

    checkClone() {
      const clones = Array.from(document.querySelectorAll('.app__clone > *'));
      const filter = clones.filter(el => el.dataset.nav === this.voice.id);
      if (filter.length === 0) {
        this.clone();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
aside {
  @include mq($until: ipadP) {
    display: none;
  }

  grid-area: b;

  .breadcrumbs {
    &__wrapper {
      position: relative;
      display: inline-block;
      margin-bottom: rem(89px);

      &[data-project] {
        margin-bottom: rem(70px);
      }
    }
    &__line {
      position: relative;
      margin-left: rem(10px);
      width: rem(50px);
      height: 1px;

      background-color: $color-dark-light;
    }
  }

  .next {
    &__wrapper {
      position: relative;
    }
    &__link {
      position: absolute;
      left: 0;
      h2 {
        color: rgba($color: $color-bg, $alpha: 0.2);
        color: $color-bg;
        white-space: nowrap;
      }
    }
  }
}
</style>
